import { useTranslation } from "react-i18next";

import { CommonNavItemProps, NavItem } from "../parts/nav_item";

export const WorkflowNavItem = (props: CommonNavItemProps) => {
  const { t } = useTranslation("translation", { keyPrefix: "navBar.items" });
  return (
    <NavItem
      icon="workflow"
      isActiveTest={(path) => path.match(/^\/workflow/)}
      name={t("workflow")}
      id="workflow"
      href="/workflow"
      {...props}
    />
  );
};
